// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"title_l0mTR","messages":"messages_axJW8","button":"button_Qail0"};